import { BaseComponent } from './basecomponent';

/**
 * Repr�sente la classe de base d'un composant module
 */
export abstract class BaseModuleComponent extends BaseComponent {
    public readonly: boolean = false;

    /**
     * Constructeur
     */
    constructor() {
        super();
    }

    /**
     * Initialiser le composant
     */
    public abstract Init(): void;
}